<template>
  <ul class="list-unstyled list-inline" v-if="Object.keys(aggregations).length && anyFilterApplied">
    <li :key="index" v-for="(filter, index) in movementsTerms">
      <RemoveFilterButton
        icon="icon-close_hit_result_map"
        :filter="filter.filter"
        :index="filter.index"
        :removeAll="filter.filter.term.length === 1"
      >
        <span>{{ termLabel(filter.term) }}</span>
      </RemoveFilterButton>
    </li>
    <li class="refresh" v-if="movementsTerms.length > 0">
      <a href class="button" @click.stop.prevent="removeAll()" v-translate><i class="icon-refresh_hit_result_map" /></a>
    </li>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex';
import RemoveFilterButton from './RemoveFilterButton.vue';
import keyToLabel from 'lib/keyToLabel';

export default {
  name: 'MovementsAppliedFilters',
  components: {
    RemoveFilterButton,
  },
  computed: {
    ...mapGetters('aggregations', ['aggregations']),
    ...mapGetters('params', ['appliedFilters', 'anyFilterApplied']),
    movementsTerms() {
      return this.appliedFilters.reduce((acc, filter) => {
        filter.term.map((term, index) => {
          const movementTerm = {
            index,
            term,
            filter: filter,
          };
          acc = [...acc, movementTerm];
        });
        return acc;
      }, []);
    },
  },
  methods: {
    termLabel(key) {
      return keyToLabel(key);
    },
    removeAll() {
      //TODO
      this.$router.push({ name: 'Movements', query: {} });
    },
  },
};
</script>
<style lang="less" scoped>
ul {
  margin: 0;

  li {
    padding: 11px 5px;
    float: left;
    margin-right: 15px;

    &:first-child {
      margin-left: 8px;
    }

    &.refresh {
      padding: 0;
      width: 42px;
      height: 42px;
      border-left: 1px solid #e0e0e0;
      margin-right: 0;

      a {
        font-size: 24px;
        text-align: center;
        background: transparent;
      }
    }

    a {
      padding: 5px 10px;
      background: darken(#fafafa, 5%);
      border-radius: 15px;
      color: #333;
      font-weight: 600;

      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
